/* Darkstone App Hub Drawer — site-wide persistent panel */
(function () {
  'use strict';

  const OPEN_CLASS = 'is-open';
  const SELECTOR_TRIGGER = '[data-app-hub-trigger]';
  const SELECTOR_DRAWER = '[data-app-hub-drawer]';
  const SELECTOR_BACKDROP = '[data-app-hub-backdrop]';
  const SELECTOR_CLOSE = '[data-app-hub-close]';
  const BODY_LOCK_CLASS = 'dshub-body-locked';

  let drawer = null;
  let backdrop = null;
  let lastTrigger = null;

  function resolveElements() {
    drawer = document.querySelector(SELECTOR_DRAWER);
    backdrop = document.querySelector(SELECTOR_BACKDROP);
  }

  function getTriggers() {
    return Array.from(document.querySelectorAll(SELECTOR_TRIGGER));
  }

  function syncTriggers(expanded) {
    getTriggers().forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (drawer) {
        trigger.setAttribute('aria-controls', drawer.id || 'dshub-drawer');
      }
    });
  }

  function openDrawer(trigger) {
    resolveElements();
    if (!drawer) return;

    lastTrigger = trigger || lastTrigger;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add(OPEN_CLASS);
    if (backdrop) {
      backdrop.setAttribute('aria-hidden', 'false');
      backdrop.classList.add(OPEN_CLASS);
    }
    document.body.classList.add(BODY_LOCK_CLASS);
    syncTriggers(true);

    const firstFocusable = drawer.querySelector('button, a, [tabindex="0"]');
    if (firstFocusable) firstFocusable.focus();
  }

  function closeDrawer(options) {
    const settings = options || {};
    resolveElements();

    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove(OPEN_CLASS);
    }
    if (backdrop) {
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.classList.remove(OPEN_CLASS);
    }
    document.body.classList.remove(BODY_LOCK_CLASS);
    syncTriggers(false);

    if (settings.restoreFocus !== false) {
      const focusTarget = lastTrigger && lastTrigger.isConnected ? lastTrigger : getTriggers()[0];
      if (focusTarget) {
        focusTarget.focus({ preventScroll: true });
      }
    }
    lastTrigger = null;
  }

  function handleClick(event) {
    const trigger = event.target.closest(SELECTOR_TRIGGER);
    if (trigger) {
      event.preventDefault();
      openDrawer(trigger);
      return;
    }

    if (event.target.closest(SELECTOR_CLOSE) || event.target.closest(SELECTOR_BACKDROP)) {
      event.preventDefault();
      closeDrawer();
    }
  }

  function init() {
    resolveElements();
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove(OPEN_CLASS);
    }
    if (backdrop) {
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.classList.remove(OPEN_CLASS);
    }
    document.body.classList.remove(BODY_LOCK_CLASS);
    syncTriggers(false);

    document.addEventListener('click', handleClick);
    document.addEventListener('darkstone:close-app-hub', function () {
      closeDrawer({ restoreFocus: false });
    });
    document.addEventListener('keydown', function (event) {
      resolveElements();
      if (event.key === 'Escape' && drawer && drawer.classList.contains(OPEN_CLASS)) {
        event.preventDefault();
        closeDrawer();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
